import { SVGProps, Ref, forwardRef } from 'react';

export const WheatFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="m2.802 11.453 2.342.59q.776.197 1.43.365c2.154.56 3.371.96 4.273 1.747a6 6 0 0 1 1.401 1.8c.613 1.204.651 2.679.653 5.486V24h-1.8v-2.002c-4.098-.005-6.243-.08-7.752-1.238a6 6 0 0 1-1.108-1.108c-1.05-1.367-1.21-3.258-1.234-6.652H1V9h1.802z"
            fill="currentColor"
        />
        <path
            d="M23.002 10h-.007c-.025 3.394-.185 5.284-1.234 6.652-.32.416-.692.789-1.108 1.108-1.276.979-3.006 1.181-5.988 1.224a20 20 0 0 0-.052-.87c-.092-1.078-.289-2.05-.76-2.976a7.8 7.8 0 0 0-1.823-2.34q-.067-.055-.133-.108a6 6 0 0 1 1.258-1.535c1.084-.946 2.624-1.335 5.703-2.111l1.795-.452.548-.139V6h1.801z"
            fill="currentColor"
        />
        <path
            d="M12.902.958c2.22 2.36 3.506 3.705 4.143 5.2q.284.673.454 1.373c-1.104.281-2.043.532-2.828.803-1.022.353-1.916.781-2.7 1.465a7.8 7.8 0 0 0-1.606 1.945q-.495-.225-1.034-.41c-.836-.289-1.848-.554-3.046-.857a8.9 8.9 0 0 1 .672-4.319c.637-1.495 1.922-2.84 4.143-5.2L12 0z"
            fill="currentColor"
        />
    </svg>
));
WheatFilledSize24Glyph.displayName = 'WheatFilledSize24Glyph';
